import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import img1 from "../assets/importexport1.jpg";
import img2 from "../assets/importexport2.jpeg";
import img3 from "../assets/importexport3.webp";
import whyExportImg from "../assets/importexportdetail1.avif"; // Add your own image here
import AnimatedCarousel from "../component/animatedcarousel/animatedcarousel";

const ExportImport = () => {
  const slides = [
    {
      img: img1,
      title: "Global Trade Expertise",
      subtitle: "Seamless Import & Export Services for Your Business",
    },
    {
      img: img2,
      title: "Global Trade Expertise",
      subtitle: "Seamless Import & Export Services for Your Business",
    },
    {
      img: img3,
      title: "Global Trade Expertise",
      subtitle: "Seamless Import & Export Services for Your Business",
    },
  ];

  const services = [
    {
      image: img1,
      title: "Export Documentation",
      description:
        "Complete assistance with all export documentation and legal compliance.",
    },
    {
      image: img2,
      title: "Customs Clearance",
      description:
        "Fast and hassle-free customs clearance for all international shipments.",
    },
    {
      image: img3,
      title: "Logistics Management",
      description:
        "Global logistics and shipping support to deliver your goods on time.",
    },
  ];

  return (
    <>
      <div style={{ overflow: "hidden" }}>
        <AnimatedCarousel slides={slides} />
        <div className="bg-light">
          <Container className="py-5">
            <h2 className="text-center mb-4">Our Import & Export Services</h2>
            <Row>
              {services.map((service, idx) => (
                <Col md={4} sm={6} xs={12} key={idx} className="mb-4">
                  <Card className="h-100 shadow-sm border-0" data-aos="zoom-in">
                    <Card.Img
                      variant="top"
                      src={service.image}
                      alt={service.title}
                      height={"220px"}
                      style={{ objectFit: "cover" }}
                    />
                    <Card.Body>
                      <Card.Title className="theme-font-color">
                        {service.title}
                      </Card.Title>
                      <Card.Text>{service.description}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>

          <Container className="py-5">
            <Row className="align-items-center">
              <Col md={6}>
                <img
                  src={whyExportImg}
                  alt="Why We Export"
                  className="img-fluid rounded shadow-sm "
                  style={{ height: "100%" }}
                  data-aos="zoom-in"
                />
              </Col>
              <Col md={6} data-aos="fade-left">
                <h3 className="fw-bold mb-3 mt-sm-3">Why We Export</h3>
                <p className="text-muted">
                  Exporting goods opens up global markets and opportunities. It
                  allows businesses to expand their reach, increase revenue, and
                  diversify customer bases across international borders.
                </p>
                <p className="text-muted mt-3">
                  Exports are incredibly important to modern economies because
                  they offer people and firms many more markets for their goods.
                  One of the core functions of diplomacy and foreign policy
                  between governments is to foster economic trade, encouraging
                  exports and imports for the benefit of all trading parties.
                </p>
                <p className="text-muted mt-3">
                  Our export services ensure smooth operations, from compliance
                  to delivery, making your global ambitions achievable with
                  confidence.
                </p>
              </Col>
            </Row>
          </Container>
          <Container className=" py-5" data-aos="fade-up">
            <p className="title-font text-start">
              Is It Better to Export Goods Than Import Goods?
            </p>
            <p className="text-muted mt-3">
              Most economic models say that countries should focus on industries
              where they have a comparative advantage, and import the goods
              where they have a comparative disadvantage. This allows countries
              to realize the benefits of specialization and economies of scale.
            </p>
            <h5 className="fw-semibold mt-3">
              1. Expanding Markets and Increased Revenue
            </h5>
            <ul className="text-muted ps-3">
              <li>
                Diversification of Sales: Reduces dependence on domestic
                markets.
              </li>
              <li>
                Access to Global Markets: Taps into new customer bases
                worldwide.
              </li>
              <li>
                New Product Development: Encourages innovation to meet global
                demand.
              </li>
            </ul>

            <h5 className="fw-semibold mt-4">
              2. Economic Growth and Foreign Exchange
            </h5>
            <ul className="text-muted ps-3">
              <li>
                Job Creation: Boosts employment opportunities across sectors.
              </li>
              <li>
                Increased Foreign Exchange: Strengthens the national economy
                through currency inflow.
              </li>
            </ul>
          </Container>
        </div>
      </div>
    </>
  );
};

export default ExportImport;
